import { render, staticRenderFns } from "./TraceDataDetail.vue?vue&type=template&id=b90ac27c&"
import script from "./TraceDataDetail.vue?vue&type=script&lang=js&"
export * from "./TraceDataDetail.vue?vue&type=script&lang=js&"
import style0 from "./TraceDataDetail.vue?vue&type=style&index=0&id=b90ac27c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports